// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","quadrado":"Header_quadrado__OfzNR","quadradoFixo":"Header_quadradoFixo__31Y1B","textoDenteInv":"Header_textoDenteInv__kEeS5"};